


import {batchUpdateDetail,updateDetailGroup,updateDetailDemoFlag,updateGroupSorts,updateDetailShelfFlag,deleteDetail,updateDetailSort,updateShelfFlag,updateDetail,createDetail,updateCopyRight,deleteGroup,updateGroup,createGroup,getGood,createGood,deleteGood,listChildrenGood,listDataGood,listGroupGood,updateGood} from "@/zsm-api-new/good.js"
const state = {

}

const mutations = {

}

const actions = {
	// 修改章节的分组
	 batchUpdateDetail({
	   commit
	 }, info) {
	   return new Promise((resolve, reject) => {
	     batchUpdateDetail(info).then(response => {
	         resolve(response)
	     }).catch(error => {
	       reject(error)
	     })
	   })
	 },
  // 修改章节的分组
   updateDetailGroup({
     commit
   }, info) {
     return new Promise((resolve, reject) => {
       updateDetailGroup(info).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
// 修改产品是否试看
   updateDetailDemoFlag({
     commit
   }, info) {
     return new Promise((resolve, reject) => {
       updateDetailDemoFlag(info).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
// 批量更新分组排序
   updateGroupSorts({
     commit
   }, ids) {
     return new Promise((resolve, reject) => {
       updateGroupSorts(ids).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
// 修改章节上下架
   updateDetailShelfFlag({
     commit
   }, info) {
    let {id,shelfFlag}=info
     return new Promise((resolve, reject) => {
       updateDetailShelfFlag(id,shelfFlag).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改商品详情排序
   deleteDetail({
     commit
   }, id) {
     return new Promise((resolve, reject) => {
       deleteDetail(id).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改商品详情排序
   updateDetailSort({
     commit
   }, data) {
     return new Promise((resolve, reject) => {
       updateDetailSort(data).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改商品上下架
   updateShelfFlag({
     commit
   }, data) {
     return new Promise((resolve, reject) => {
       updateShelfFlag(data).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改章节
   updateDetail({
     commit
   }, data) {
     return new Promise((resolve, reject) => {
       updateDetail(data).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 创建章节
   createDetail({
     commit
   }, data) {
     return new Promise((resolve, reject) => {
       createDetail(data).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改版权内容
   updateCopyRight({
     commit
   }, id) {
     return new Promise((resolve, reject) => {
       updateCopyRight(id).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 修改分组
   updateGroup({
     commit
   }, id) {
     return new Promise((resolve, reject) => {
       updateGroup(id).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
  // 新增分组
   deleteGroup({
     commit
   }, id) {
     return new Promise((resolve, reject) => {
       deleteGroup(id).then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
 // 新增分组
  createGroup({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      let {goodId,name} =info
      createGroup(goodId,name).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改课程
  getGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      getGood(id).then(response => {
          resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改课程
  updateGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateGood(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看课程的分组
  listGroupGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      listGroupGood(id).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取课程列表
  listDataGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataGood(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看课程的章节
  listChildrenGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listChildrenGood(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除课程
  deleteGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteGood(id).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建课程
  createGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createGood(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /* //  获取后台配置字典
  getByDictValueList({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getByDictValue(dictValue).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //  获取后台配置字典
  getValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfigValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getConfigValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  } */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
